export const ALLOWED_REPORT_DOMAINS = [
  'tableaustaging.deloitte.com.au',
  'tableau.deloitte.com.au',
  'app.powerbi.com',
]
